import { render, staticRenderFns } from "./RepairRegistrationJJList.vue?vue&type=template&id=05c5a778&scoped=true&"
import script from "./RepairRegistrationJJList.vue?vue&type=script&lang=js&"
export * from "./RepairRegistrationJJList.vue?vue&type=script&lang=js&"
import style0 from "./RepairRegistrationJJList.vue?vue&type=style&index=0&id=05c5a778&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c5a778",
  null
  
)

export default component.exports